// components/GlobalLoader.jsx
import { useSelector } from 'react-redux';
import '../styles/loader.css';

export default function GlobalLoader() {
  const loadingCount = useSelector(
    (state) => state.loader.loadingCount
  );

  if (loadingCount === 0) return null;

  return (
    <div className="loader-overlay">
      <div className="spinner"></div>
    </div>
  );
}